<template>
  <div class="_row" @click="click()">
    <div>{{ item.title }}</div>
    <div>{{ item.area }}</div>
    <div>{{ item.price | thousands }} руб.</div>
    <div>{{ item.category }}</div>
    <div>{{ item.comment }}</div>
  </div>
</template>

<script>
export default {
  name: "ParkingTableRow",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    click() {
      this.$emit("click")
    },
  },
}
</script>
